import axios from 'axios'
import endpoints from '../configuration/endpoints'
import triggerCustomGaEvent from '../utils/triggerCustomGaEvent'
import formatImages from '../utils/formatImages'

export const REQUEST_BRAND_DETAILS = 'REQUEST_BRAND_DETAILS'
export const RECEIVE_BRAND_DETAILS = 'RECEIVE_BRAND_DETAILS'
export const BRAND_DETAILS_ERROR = 'BRAND_DETAILS_ERROR'

const requestBrandDetails = () => ({
  type: REQUEST_BRAND_DETAILS
})

const formatBrandDetails = brands => {
  return brands
    .filter(brand => brand.brand_code !== 'Z')
    .reduce((obj, brand) => {
      const brandKey = brand.brand_code

      obj[brandKey] = {
        ...brand,
        image: formatImages(brand.image, ['details-hero'])
      }

      return obj
    }, {})
}

const receiveBrandDetails = brands => ({
  type: RECEIVE_BRAND_DETAILS,
  payload: brands
})

const brandDetailsError = () => ({
  type: BRAND_DETAILS_ERROR
})

export const fetchBrandDetails = () => dispatch => {
  dispatch(requestBrandDetails())

  return axios
    .get(endpoints.brands)
    .then(res => {
      const brands = formatBrandDetails(res.data)
      triggerCustomGaEvent('package-brand-data', brands)
      dispatch(receiveBrandDetails(brands))
    })
    .catch(() => {
      dispatch(brandDetailsError())
    })
}
